import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import getBrandTileReviews from "@faire/web-api--source/api/v2/products/search/brand-tile-reviews/post";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useSearchPageBrandTilesRelatedToSearch } from "@faire/retailer/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageBrandTilesRelatedToSearch";
import { useSearchPageQueryIsLoading } from "@faire/retailer/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageQueryIsLoading";
import { useSearchPageProductSearchString } from "@faire/retailer/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";

const SEARCH_PAGE_BRAND_TILE_REVIEWS_QUERY_KEY = "SearchPageBrandTileReviews";

export const useSearchPageLoggedOutBrandTileReviewsQuery = () => {
  const isLoggedInRetailer: boolean = useIsLoggedInRetailer();

  // Do not fetch reviews if the user is logged in
  const { brandTilesRelatedToSearch } =
    useSearchPageBrandTilesRelatedToSearch(!isLoggedInRetailer);
  const query = useSearchPageProductSearchString();
  const isProductsResponseLoading = useSearchPageQueryIsLoading();

  const brandTokens = useMemo(
    () =>
      brandTilesRelatedToSearch
        ?.map((item) => item.brand?.token)
        .filter(isNotUndefined) ?? [],
    [brandTilesRelatedToSearch]
  );

  return useQuery({
    queryKey: [SEARCH_PAGE_BRAND_TILE_REVIEWS_QUERY_KEY, brandTokens, query],
    queryFn: async ({ signal }) => {
      return await getBrandTileReviews(
        { brand_tokens: brandTokens, query },
        { signal }
      );
    },
    enabled:
      !isLoggedInRetailer &&
      brandTokens.length > 0 &&
      !isProductsResponseLoading,
    staleTime: Infinity,
    placeholderData: keepPreviousData,
  });
};
